import { ApiService } from './api/api'
import type { AxiosResponse } from 'axios'

export default class MailchimpService {
	private apiService

	constructor() {
		this.apiService = new ApiService(false, '2')
	}

	/**
	 * Get all mail lists
	 * @returns Promise
	 */
	getLists(): Promise<AxiosResponse> {
		return this.apiService.get(`/mailchimp/lists`)
	}

	/**
	 * Get list by id
	 * @param id
	 */
	getList(id: string): Promise<AxiosResponse> {
		return this.apiService.get(`/mailchimp/lists/${id}`)
	}

	/**
	 * Create a new list
	 * @param params
	 */
	create(params: Object): Promise<AxiosResponse> {
		return this.apiService.post(`/mailchimp/lists/create`, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
	}
}
